import { useEffect } from 'react';
import { Storage, translate } from 'react-jhipster';

import { useAppSelector } from 'app/config/store';

const EZRA_WIDGET_SRC = 'https://chat.sh-trade.net/content/widget/ezra-widget.js';
const EZRA_UAT_INTEGRATION_ID = '6a79b28ed7259fb7c1ea51d1';
const EZRA_PROD_INTEGRATION_ID = '6aeb3cd62835da0d5373e526';
const UAT_HOSTS = ['localhost', '127.0.0.1', 'comexdev.com'];

/**
 * Both integration IDs live in every branch so uat -> main -> prod merges never
 * flip the value. localhost and comexdev.com (incl. subdomains) use uat; anything else is prod.
 */
const resolveIntegrationId = (hostname: string) =>
  UAT_HOSTS.some(host => hostname === host || hostname.endsWith(`.${host}`)) ? EZRA_UAT_INTEGRATION_ID : EZRA_PROD_INTEGRATION_ID;

const EZRA_INTEGRATION_ID = resolveIntegrationId(window.location.hostname);
const EZRA_SCRIPT_ID = 'ezra-widget-script';
const EZRA_FRAME_ID = 'ezra-widget-frame';

/**
 * Injects the Ezra AI chat widget snippet (self-contained floating bubble + panel,
 * rendered by Ezra inside its own iframe). The widget exchanges the raw Comex JWT
 * for a short-lived embed token itself (US-908), so data-token is just the user's
 * current signed-in token - it already carries bankId/branchId for Ezra's row-level
 * scoping.
 */
const EzraChatWidget = () => {
  const currentLocale = useAppSelector(state => state.locale.currentLocale);

  useEffect(() => {
    const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');
    if (!token) {
      return undefined;
    }

    const script = document.createElement('script');
    script.id = EZRA_SCRIPT_ID;
    script.src = EZRA_WIDGET_SRC;
    script.async = true;
    script.dataset.integrationId = EZRA_INTEGRATION_ID;
    script.dataset.token = token;
    script.dataset.color = '#2563eb';
    script.dataset.accentColor = '#2563eb';
    script.dataset.label = translate('global.aiChat.askAi');
    document.body.appendChild(script);

    return () => {
      script.remove();
      document.getElementById(EZRA_FRAME_ID)?.remove();
    };
  }, [currentLocale]);

  return null;
};

export default EzraChatWidget;
